import { render, staticRenderFns } from "./GradeCurricular.vue?vue&type=template&id=49f74890&scoped=true&lang=pug&"
import script from "./GradeCurricular.vue?vue&type=script&lang=js&"
export * from "./GradeCurricular.vue?vue&type=script&lang=js&"
import style0 from "./GradeCurricular.styl?vue&type=style&index=0&id=49f74890&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49f74890",
  null
  
)

export default component.exports